export const BASE_URL_WEBSITE = 'https://r-tattersall-qa.herokuapp.com'
export const HOST = 'https://api.rematetattersallgda.com'

export const PATH = {
  AUCTION: `${HOST}:3003/auction`,
  SESSION: `${HOST}/session`,
  GUARANTEES: `${HOST}/guarantee`,
  EMAIL: `${HOST}/email`,
  SOCKET_AUCTION: `${HOST}/socket`,
  LOAD_INIT: `${HOST}/loadinit`,
}

export const WEB = {
  BASE: 'http://localhost:3000',
  HOME: '/',
  EXPIRED: '/expired',
  LOGIN_URL: '/login',
}
export const URL_TCIT = {
  BASE: 'https://r-tattersall-qa.herokuapp.com',
  URL: '/login',
}
export const NAME = 'localAws'
